import { ReactComponent as Icon } from "../files/star-filled.svg";

import ISVGIconProps from "../ISVGIconProps";

const DocumentIcon = ({ fill, style = {} }: ISVGIconProps) => {
    return <Icon style={style} fill={fill} />;
};

export default DocumentIcon;
